import React, { FC, useEffect, useMemo, useRef } from 'react';
import locales from '../../../../../../content.json';
import { getDay } from '../../../../../../utils/scripts/getDay';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../../../store';
import { getCurrencySymbol } from '../../../../../../utils/scripts/currency';
import { getIntroDay } from '../../../../../../utils/scripts/getDay';
import s from './index.module.scss';

export const Disclaimer:FC = () => {
  const product = useSelector((state: RootState) => {
    return state.data.paymentModal.product.details;}
  );
  const text1Ref = useRef(null);
  const text2Ref = useRef(null);
  const text3Ref = useRef(null);
  const text4Ref = useRef(null);
  const currency = getCurrencySymbol();

  useEffect(() => {
      if (product) {

        if (text1Ref?.current) {
          if(text1Ref.current.querySelector('b') && product.trial_amount) {
            text1Ref.current.querySelector('b').textContent = `${currency}${product.trial_amount}`;
          }
          if (product?.duration?.trial_period_unit === 'week' || product?.duration?.trial_period_value === 7) {
            text1Ref.current.querySelector('span').textContent = locales[window.userLang].payment_text_119;
          } else {
            text1Ref.current.querySelector('span').textContent = `${product?.duration?.trial_period_value * 4} ${locales[window.userLang].payment_text_68}`;
          }
        }

        if (text2Ref?.current) {
          if(text2Ref.current.querySelector('b') && product.trial_amount) {
            text2Ref.current.querySelector('b').textContent = getIntroDay(product);
          }
        }
        if (text3Ref?.current) {
          if(text3Ref.current.querySelector('b') && product.trial_amount) {
            text3Ref.current.querySelector('b').textContent = getIntroDay(product);
          }
        }
        if (text4Ref?.current) {
          if(text4Ref.current.querySelector('b') && product.trial_amount) {
            text4Ref.current.querySelector('b').textContent = `${currency}${product.amount}`;
          }
        }
      }
  
    }, [product, text1Ref, text2Ref, text3Ref, text4Ref]);

    const text4 = useMemo(() => {
      let text4Value;
      if (product?.duration?.value && product?.duration?.unit) {
        if (product?.duration?.unit === 'month') {
          if (product?.duration?.value === 3) {
            text4Value = locales[window.userLang].payment_text_126;
          } else if (product?.duration?.value === 6) {
            text4Value = locales[window.userLang].payment_text_127;
          } else {
            text4Value = locales[window.userLang].payment_text_85;
          }
        } else if (product?.duration?.unit === 'week') {
          if (product?.duration?.value === 2) {
            text4Value = locales[window.userLang].payment_text_196;
          }
        }
      }

      return text4Value;
    }, [product]);

  return (
    <div className={s.warning}>
        <ul className={s.items}>
          <li className={s.item}>
            <p dangerouslySetInnerHTML={{ __html: locales[window.userLang].payment_text_124 }} />
          </li>
          <li className={s.item}>
            <p ref={text1Ref} dangerouslySetInnerHTML={{ __html: locales[window.userLang].payment_text_120 }} />
          </li>
          <li className={s.item}>
            <p ref={text2Ref} dangerouslySetInnerHTML={{ __html: locales[window.userLang].payment_text_83 }} />
          </li>
          <li className={s.item} >
            <p ref={text3Ref} dangerouslySetInnerHTML={{ __html: locales[window.userLang].payment_text_84 }} />
          </li>
          <li className={s.item}>
            <p ref={text4Ref} dangerouslySetInnerHTML={{ __html: text4 }} />
          </li>
          <li className={s.item}>
            <p dangerouslySetInnerHTML={{ __html: locales[window.userLang].payment_text_51 }} />
          </li>
        </ul>
      </div>
  );
};

